import { render } from "./SalesReportExclusionsInfo.vue?vue&type=template&id=a47930e6"
import script from "./SalesReportExclusionsInfo.vue?vue&type=script&lang=js"
export * from "./SalesReportExclusionsInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__